// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sozxK","index":"styles_index__1tKMj"};